import {Routes} from '@angular/router';
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import {RemoteConfigResolver} from '@softline/application';
import {BestellvorschlagResolver} from './resolver/bestellvorschlag.resolver';
import {SOFTLINE_PERMISSION_MDE_BESTELLVORSCHLAG} from './bestellvorschlag.shared';

export const bestellvorschlagRoutes: Routes = [
  {
    path: 'mde-bestellvorschlag',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/bestellvorschlag.component').then(
            (o) => o.BestellvorschlagComponent
          ),
        children: [
          {
            path: 'liefertermin',
            loadComponent: () => import('./pages/liefertermin/liefertermin.component').then(
              o => o.LieferterminComponent
            )
          },
          {
            path: 'artikel-erfassen',
            loadComponent: () => import('./pages/artikel-erfassen/artikel-erfassen.component').then(
              c => c.ArtikelErfassenComponent
            ),
            loadChildren: () => [
              {
                loadComponent: () => import('./pages/artikel-erfassen/schritt1/schritt1.component').then(
                  c => c.Schritt1Component
                ),
                path: 'suche'
              },
              {
                loadComponent: () => import('./pages/artikel-erfassen/schritt2/schritt2.component').then(
                  c => c.Schritt2Component
                ),
                path: ':idartstamm'
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: '/mde-bestellvorschlag/artikel-erfassen/suche'
              }
            ]
          },
          {
            path: '',
            loadComponent: () => import('./pages/erfassung/erfassung.component').then(
              o => o.ErfassungComponent
            )
          },
          {
            path: '**',
            redirectTo: '/mde-bestellvorschlag'
          },
        ],
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_MDE_BESTELLVORSCHLAG },
    resolve: { config: RemoteConfigResolver, bestellvorschlag: BestellvorschlagResolver },
    providers: [],
  },
];
